module.exports = __webpack_public_path__ + "static/media/office-cluj@2x.08358237.png";